import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Errorandloading/Loading";
import { fetchCategories, fetchCategoryById } from "../../../redux/feature/categorySlice";
import { fetchProducts } from "../../../redux/feature/productSlice";
import JewelleryGrid from "../../jewellery/components/JewelleryGrid";
import DiscoverHeader from "../../jewellery/components/DiscoverHeader";

export default function DiscoverAll() {
  const { category } = useParams();
  const dispatch = useDispatch();
  const [categoryId, setCategoryId] = useState(category || "");
  const location = useLocation(); 
  const queryParams = new URLSearchParams(location.search);
  const collection = queryParams.get("collection");
  const { selected } = useSelector((state) => state.category);
  const { items: products, loading: productLoading } = useSelector(
    (state) => state.products
  );
   const { list: categories } = useSelector(
      (state) => state.category
    );
  
  const [filters, setFilters] = useState({
    gender: "",
    search: "",
    page: 1,
    limit: null,
    country: "INR",
    priceMin: null,
    priceMax: null,
    isTopCollection: false,
  });
  useEffect(() => {
    if (category) dispatch(fetchCategoryById(category));
  }, [category, dispatch]);
    useEffect(() => {
      dispatch(fetchCategories());
    }, [dispatch]);

  useEffect(() => {
    dispatch(
      fetchProducts({
        categoryId,
        collection: collection,
        ...filters,
      })
    );
  }, [category,categoryId, collection, filters, dispatch]);

  if (productLoading) return <Loading />;
  return (
    <Box>
      <DiscoverHeader
      setCategoryId ={setCategoryId}
        category={selected}
        Allcategories={categories}
        products={products}
        filters={filters}
        setFilters={setFilters}
        collection={collection}
      />

      <JewelleryGrid products={products} />
    </Box>
  );
}
